import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import $ from "jquery";
import {
  showFilterlist,
  subscriptionPlanType,
  SWAL_SETTINGS,
} from "../../../../utils/Constants";
import {
  formateDateWithMonth,
  handleServerValidations,
  TrimText,
} from "../../../../utils/commonfunction";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import CustomRangepicker from "../../common/rangepicker";
import StatusFilter from "../../common/statusFilter";
import CustomPagination from "../../common/custompagination";
import {
  SubscriptionPlanDelete,
  SubscriptionPlanList,
  SubscriptionPlanStatus,
} from "../../services/subscriptionPlan.services";
import { SubscriptionFeatureList } from "../../services/subscriptionFeature.services";

const SubscriptionPlanTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Subscription plan"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [allFeatures, setAllFeatures] = useState([]);
  const [featureModal, setFeatureModal] = useState({
    isOpen: false,
    planId: null,
    planSlug: "",
    planName: "",
  });

  const getPlanRule = (feature, planSlug) =>
    (feature?.plan_rules || []).find((rule) => rule.plan_slug === planSlug);

  const allowedFeaturesForPlan = (planSlug) =>
    allFeatures.filter((feature) => getPlanRule(feature, planSlug)?.allowed);

  const quotaLabel = (rule) => {
    if (!rule?.allowed) return "Not allowed";
    if (rule.quota_type === "unlimited") return "Unlimited";
    if (rule.quota_type === "limited") {
      return `Limited: ${rule.limit || 0} / year`;
    }
    return "Allowed";
  };

  const queryParams = new URLSearchParams(location.search);
  const devParam = queryParams.get("dev");
  const showAddButton = devParam === "true";
  const [isDevMode, setIsDevMode] = useState(showAddButton);

  useEffect(() => {
    setIsDevMode(showAddButton);
  }, [showAddButton]);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        SubscriptionPlanList(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);

    // Also fetch features for the modal
    SubscriptionFeatureList()
      .then((data) => {
        setAllFeatures(data?.data?.list || []);
      })
      .catch((error) => console.log("error fetching features", error));

    return () => clearTimeout(getData);
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(`/admin/subscription/subscription-plan/view/${row._id}`);
  };

  const ChangeStatus = (data, Num) => {
    // let ids = Array.isArray(data) ? data : [data];
    const formData = new FormData();
    // formData.append("o_id", JSON.stringify(ids));
    formData.append("o_id", data);
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t(
        `Are you sure you want to ${Num === 0 ? "inactive" : "active"} this Plan ?`,
      ),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    }).then((result) => {
      // console.log("result", result);
      if (result.isConfirmed) {
        SubscriptionPlanStatus(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  function Deletefunction(data) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        SubscriptionPlanDelete(data)
          .then((response) => {
            // console.log("🚀 ~ .then ~ response:", response);
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    // $("#defaultstatus")[0].selectedIndex = 0;
  };

  const goToEdit = (row) => {
    navigate(`/admin/subscription/subscription-plan/edit/${row._id}`);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Subscription plan")}</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
                {isDevMode && (
                  <button
                    className="btn ripple btn-main-primary signbtn mr-2"
                    onClick={() =>
                      navigate(`/admin/subscription/subscription-plan/add`)
                    }
                  >
                    {t("btn_add_new")}
                  </button>
                )}
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>

                    <th>
                      <div className="sorting_column">
                        <span>{t("Plan name")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="plan_name"
                        />
                      </div>
                    </th>

                    <th>
                      <div className="sorting_column">
                        <span>{t("Plan duration")}</span>
                      </div>
                    </th>

                    <th className="position-relative select_head">
                      <span>{t("Plan price")}</span>
                    </th>

                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    <th className="status_head">{t("list_heading_status")}</th>
                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={14}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {row ? (page - 1) * itemperpage + i + 1 : null}
                              </td>
                              <td>{row?.name || row?.plan_name || "N/A"}</td>
                              <td>{row?.duration || row?.plan_duration || "N/A"}</td>
                              <td>{row?.price ?? row?.plan_price ?? "N/A"}</td>
                              <td>
                                {row.createdAt
                                  ? formateDateWithMonth(row.createdAt)
                                  : "N/A"}
                              </td>
                              <td>
                                {row.status === 1 ? (
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      ChangeStatus(row?._id, 0);
                                    }}
                                  >
                                    {t("btn_active")}
                                  </button>
                                ) : (
                                  <button
                                    className="btn ripple btn-secondary"
                                    onClick={() => {
                                      ChangeStatus(row?._id, 1);
                                    }}
                                  >
                                    {t("btn_inactive")}
                                  </button>
                                )}
                              </td>

                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      viewfunction(row);
                                    }}
                                  >
                                    {t("btn_view")}
                                  </button>

                                  <button
                                    className="btn ripple btn-info mlAction"
                                    onClick={() => {
                                      setFeatureModal({
                                        isOpen: true,
                                        planId: row._id,
                                        planSlug: row.slug,
                                        planName: row.name || row.plan_name || "Plan",
                                      });
                                    }}
                                  >
                                    <i className="fa fa-list me-1"></i> {t("Features")}
                                  </button>

                                  <button
                                    className="btn ripple btn-success mlAction"
                                    onClick={() => {
                                      goToEdit(row);
                                    }}
                                  >
                                    {t("btn_edit")}
                                  </button>
                                  {isDevMode && (
                                    <button
                                      className="btn ripple btn-secondary mlAction"
                                      onClick={() => {
                                        Deletefunction(row?._id);
                                      }}
                                    >
                                      {t("btn_delete")}
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Psychic",
                    path: "/admin/subscription/subscription-plan/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      {/* Plan Features Overview Modal */}
      {featureModal.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            zIndex: 999999999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflowY: "auto",
            padding: "20px"
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setFeatureModal({ isOpen: false, planId: null, planSlug: "", planName: "" });
            }
          }}
        >
          <div className="bg-transparent" style={{ width: "95%", maxWidth: "520px", zIndex: 10 }}>
            {(() => {
              const assignedFeatures = allowedFeaturesForPlan(featureModal.planSlug);

              return (
                <div className="card shadow border-0 overflow-hidden">
                  <div className="card-header bg-primary text-white text-center py-3 position-relative">
                    <h5 className="m-0 font-weight-bold text-uppercase">{featureModal.planName || "Plan"}</h5>
                    <span className="badge bg-white text-primary mt-2">{assignedFeatures.length} Features</span>
                    <button
                      type="button"
                      className="btn-close btn-close-white position-absolute"
                      style={{ top: '15px', right: '15px' }}
                      onClick={() => setFeatureModal({ isOpen: false, planId: null, planSlug: "", planName: "" })}
                    />
                  </div>
                  <div className="card-body p-0 bg-white" style={{ maxHeight: "60vh", overflowY: "auto", overflowX: "hidden" }}>
                    <div className="p-3">
                      <ul className="list-unstyled mb-0">
                        {assignedFeatures.length > 0 ? (
                          assignedFeatures.map((feature) => {
                            const rule = getPlanRule(feature, featureModal.planSlug);
                            return (
                              <li key={feature._id || feature.slug} className="py-2 border-bottom d-flex align-items-start">
                                <div className="bg-success text-white rounded-circle d-flex justify-content-center align-items-center me-3 mt-1" style={{ width: '20px', height: '20px', fontSize: '11px' }}>
                                  <i className="fa fa-check"></i>
                                </div>
                                <div>
                                  <div style={{ fontSize: '15px' }}>{feature.name || feature.feature}</div>
                                  <small className="text-muted">{quotaLabel(rule)}</small>
                                </div>
                              </li>
                            );
                          })
                        ) : (
                          <li className="text-center text-muted py-4">
                            <i className="fa fa-times-circle text-danger mb-2 fs-4 d-block"></i>
                            <span>{t("No features assigned to this plan.")}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className="card-footer bg-white border-top text-center p-3">
                    <button
                      className="btn btn-outline-primary me-2"
                      onClick={() => {
                        setFeatureModal({ isOpen: false, planId: null, planSlug: "", planName: "" });
                        navigate("/admin/subscription/subscription-feature");
                      }}
                    >
                      Manage features
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={() => setFeatureModal({ isOpen: false, planId: null, planSlug: "", planName: "" })}
                    >
                      {t("Close")}
                    </button>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionPlanTable;
